import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IGetRestaurantResponse } from '../../proto/restaurant/restaurant';

export interface IAuthState {
	selectedRestaurantId: IGetRestaurantResponse['id'];
	token: string;
}

const initialState: IAuthState = {
	selectedRestaurantId: null,
	token: null,
};

export const {
	reducer,
	actions: { setSelectedRestaurantID, setToken },
} = createSlice({
	name: 'auth',
	initialState,
	reducers: {
		setSelectedRestaurantID: (state, action: PayloadAction<string>): void => {
			state.selectedRestaurantId = action.payload;
		},
		setToken: (state, action: PayloadAction<string>): void => {
			state.token = action.payload;
		},
	},
});
